import { TableCell, TableRow } from '@mui/material';

import { Shimmer } from './Shimmer';

interface TableSkeletonProps {
  /** Must match the header's column count so the placeholder aligns with it. */
  columns: number;
  rows?: number;
  /** Row height — match the real row so the table doesn't jump on load. */
  rowHeight?: number;
}

// Varying bar widths per column read as content rather than a progress bar.
// Cycled by column index, so every row shares one rhythm instead of looking
// random — which is what a real table of values looks like.
const WIDTHS = ['70%', '55%', '80%', '45%', '65%', '50%', '75%', '40%', '60%'];

/**
 * Placeholder rows for a data table, rendered inside an existing <TableBody> so
 * the real header and column widths stay put while data loads.
 *
 * Responsive by inheritance: the parent table already scrolls inside its own
 * overflow container, and these cells simply follow its column widths.
 */
export const TableSkeleton = ({ columns, rows = 6, rowHeight = 49 }: TableSkeletonProps) => (
  <>
    {Array.from({ length: rows }, (_, rowIdx) => (
      <TableRow key={rowIdx} sx={{ height: rowHeight }}>
        {Array.from({ length: columns }, (_, colIdx) => (
          <TableCell
            key={colIdx}
            sx={(theme) => ({ p: '10px', borderBottom: `1px solid ${theme.palette.grey[200]}` })}
          >
            <Shimmer height={12} width={WIDTHS[colIdx % WIDTHS.length]} />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);
